// extracted by mini-css-extract-plugin
export var chip = "_e4-0";
export var filterDropdown = "_e4-5";
export var filterItem = "_e4-6";
export var icon = "_e4-1";
export var removeButton = "_e4-3";
export var removeIcon = "_e4-4";
export var separator = "_e4-2";